// Preloader para recursos críticos da aplicação
export const preloadCriticalResources = () => {
  // Preload de fontes críticas
  const fontPreloads = [
    'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap'
  ];

  fontPreloads.forEach(fontUrl => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = fontUrl;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
    
    // Carregar o CSS imediatamente após o preload para evitar o warning
    setTimeout(() => {
      const styleLink = document.createElement('link');
      styleLink.rel = 'stylesheet';
      styleLink.href = fontUrl;
      styleLink.crossOrigin = 'anonymous';
      document.head.appendChild(styleLink);
    }, 0);
  });

  // Preload de módulos críticos usando modulepreload
  // Removido preload de módulos específicos pois o Vite já gerencia isso automaticamente
  // e estava causando erros 404 no desenvolvimento
};

// Preload de recursos específicos para a página de login
export const preloadLoginResources = () => {
  // Preload de ícones que serão usados na página de login
  const iconPreloads = [
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjU2IDEyLjI1YzAtLjc4LS4wNy0xLjUzLS4yLTIuMjVIMTJ2NC4yNmg1LjkyYy0uMjYgMS4zNy0xLjA0IDIuNTMtMi4yMSAzLjMxdjIuNzdoMy41N2MyLjA4LTEuOTIgMy4yOC00Ljc0IDMuMjgtOC4wOXoiIGZpbGw9IiM0Mjg1RjQiLz4KPHBhdGggZD0iTTEyIDIzYzIuOTcgMCA1LjQ2LS45OCA3LjI4LTIuNjZsLTMuNTctMi43N2MtLjk4LjY2LTIuMjMgMS4wNi0zLjcxIDEuMDYtMi44NiAwLTUuMjktMS45My02LjE2LTQuNTNIMi4xOHYyLjg0QzMuOTkgMjAuNTMgNy43IDIzIDEyIDIzeiIgZmlsbD0iIzM0QTg1MyIvPgo8cGF0aCBkPSJNNS44NCAxNC4wOWMtLjIyLS42Ni0uMzUtMS4zNi0uMzUtMi4wOXMuMTMtMS40My4zNS0yLjA5VjcuMDdIMi4xOEMxLjQzIDguNTUgMSAxMC4yMiAxIDEyczQuNDMgMy40NSAxLjE4IDQuOTNsMi44NS0yLjIyLjgxLS42MnoiIGZpbGw9IiNGQkJDMDUiLz4KPHBhdGggZD0iTTEyIDUuMzhjMS42MiAwIDMuMDYuNTYgNC4yMSAxLjY0bDMuMTUtMy4xNUMxNy40NSAyLjA5IDE0Ljk3IDEgMTIgMSA3LjcgMSAzLjk5IDMuNDcgMi4xOCA3LjA3bDMuNjYgMi44NGMuODctMi42IDMuMy00LjUzIDYuMTYtNC41M3oiIGZpbGw9IiNFQTQzMzUiLz4KPC9zdmc+'
  ];

  // Preload de imagens críticas como base64 para evitar requests adicionais
  iconPreloads.forEach(iconData => {
    const img = new Image();
    img.src = iconData;
  });
};

// Função para inicializar todos os preloads
export const initializePreloads = () => {
  // Executar preloads apenas se o navegador suportar
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      preloadCriticalResources();
      preloadLoginResources();
    });
  } else {
    // Fallback para navegadores que não suportam requestIdleCallback
    setTimeout(() => {
      preloadCriticalResources();
      preloadLoginResources();
    }, 100);
  }
};
